// extracted by mini-css-extract-plugin
export default {"box":"burger-ingredient_box__fwc2T","dragging":"burger-ingredient_dragging__gmTeo","price":"burger-ingredient_price__hoHrd"};